import HooverHeroSection from "./components/HeroSection";
import HooverStickyNav from "./components/StickyNav";
import HooverProcessingTimeSection from "./components/ProcessingTimeSection";
import HooverServicesSection from "./components/ServicesSection";
import HooverLocalAreaSection from "./components/LocalAreaSection";
import HooverTravelTimingSection from "./components/TravelTimingSection";
import HooverDestinationsSection from "./components/DestinationsSection";
import HooverTestimonialsSection from "./components/TestimonialsSection";
import HooverAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import HooverComparisonSection from "./components/ComparisonSection";
import HooverMistakesSection from "./components/MistakesSection";
import HooverHowItWorksSection from "./components/HowItWorksSection";
import HooverFAQSection, { faqs } from "./components/FAQSection";
import HooverHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import HooverFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

export default function HooverPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Hoover"
        state="Alabama"
        stateAbbr="AL"
        route="/cities/hoover"
        title="Emergency Passport Hoover, AL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Hoover, AL — as fast as 24 hours. Serving Riverchase executives, Vestavia Hills professionals, and Greater Birmingham south suburbs. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Hoover, Alabama"
        geoPosition="33.4050;-86.8113"
        faqs={faqsMapped}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Hoover travelers with immediate departure needs — as fast as 24 hours for Birmingham south suburb residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Hoover with a passport issued within the last 15 years." },
          { name: "New Passport", description: "First-time passport application assistance for Hoover and Vestavia Hills residents." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Hoover, AL." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Hoover families." },
          { name: "Name Change", description: "Passport correction and name change service for Riverchase and Greater Birmingham residents." },
          { name: "Second Passport", description: "Second passport service for frequent international business travelers from the Hoover corporate community." },
        ]}
        statePageName="Alabama"
        statePageRoute="/states/alabama"
      />
      <HooverHeroSection />
      <HooverStickyNav />
      <HooverProcessingTimeSection />
      <HooverLocalAreaSection />
      <HooverServicesSection />
      <HooverTravelTimingSection />
      <HooverDestinationsSection />
      <HooverTestimonialsSection />
      <HooverAcceptanceFacilitiesSection />
      <HooverComparisonSection />
      <HooverMistakesSection />
      <HooverHowItWorksSection />
      <HooverFAQSection />
      <HooverHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/hoover" state="AL" />
      <HooverFinalCTA />
    </div>
  );
}